import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect } from 'react';
import useSearch from '../useSearch';
function useSearchResults({
  queryKey,
  resultKeys,
  entities,
  fields,
  queryHook
}) {
  const [currentResults, setCurrentResults] = useState([]);
  const [allResults, setAllResults] = useState([]);
  const [{
    searchedValue,
    loading,
    data: {
      results,
      total
    }
  }, setParams] = useSearch({
    queryKey,
    resultKeys,
    entities,
    fields,
    queryHook
  });
  useEffect(() => {
    if (currentResults.length !== results.length) {
      setAllResults([...allResults, ...results]);
      setCurrentResults(results);
    }
  }, [allResults, currentResults, results]);
  const clearList = params => {
    setAllResults([]);
    setParams(_objectSpread(_objectSpread({}, params), {}, {
      offset: 0
    }));
  };
  const setQueryParams = params => {
    params.value !== searchedValue ? clearList(params) : setParams(params);
  };
  return [{
    loading,
    results: allResults,
    currentResults,
    newResults: results,
    total
  }, setQueryParams];
}
export default useSearchResults;
//# sourceMappingURL=useSearchResults.js.map